module.exports = __webpack_public_path__ + "static/media/wave-8.888aa962.svg";